module.exports = __webpack_public_path__ + "img/anzihong.82573692.png";